import { MagnifyingGlassCircleIcon as SearchIcon } from "@heroicons/react/24/outline";
import React, { useContext, useState } from "react";
import ProjectDetail from "../components/ProjectDetail";
import { portfolioConfig } from "../config/portfolio.config";
import { ThemeContext } from "../contexts/ThemeContext";

const Explore = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const { darkMode } = useContext(ThemeContext);

  const filteredPosts = portfolioConfig.posts.filter((post) =>
    post.caption.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-6xl px-4 mx-auto">
      {/* Search Bar */}
      <div className="relative mb-6">
        <SearchIcon
          className={`absolute w-5 h-5 ${
            darkMode ? "text-gray-400" : "text-gray-400"
          } transform -translate-y-1/2 left-3 top-1/2`}
        />
        <input
          type="text"
          placeholder="Search posts"
          className={`w-full py-2 pl-10 pr-4 border   ${
            darkMode ? "border-gray-700" : "border-gray-300"
          } ${
            darkMode ? "bg-gray-950" : "bg-white"
          }  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Explore Grid */}
      <div className="grid grid-cols-3 gap-1 md:gap-4">
        {filteredPosts.map((post) => (
          <div
            key={post.id}
            className="relative cursor-pointer aspect-square"
            onClick={() => setSelectedPost(post)}
          >
            <img
              src={post.image}
              alt={post.caption}
              className="object-cover w-full h-full"
            />
            <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-300 bg-black bg-opacity-0 hover:bg-opacity-50">
              <p className="font-semibold text-center text-white transition-opacity duration-300 opacity-0 hover:opacity-100">
                {post.caption}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Project Detail Modal */}
      {selectedPost && (
        <ProjectDetail
          project={selectedPost}
          onClose={() => setSelectedPost(null)}
        />
      )}
    </div>
  );
};

export default Explore;
